import { HP, legSwing, pt } from '../enemy-parts';
import { clamp } from '../../core/math';
/* ============================================================
   家族 RING 環 —— 環
   ============================================================

   由 `tools/port-families.mjs` 從 `enemy_sample_ani.html` §5 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-families.mjs --check`（逐一比對數字字面值序列）。

   本族成員（威脅色決定身分，剪影決定家族）：
     NEST    azu 巢　召喚・增援
     REIFEN  red 箍　滾進・纏繞
     KRANZ   amb 冠　環射・壓制
     WIRBEL  vio 渦　旋渦・吸引
     MAUL    red 顎　深層・咬合
     LEIER   amb 弦琴　深層・弦射

   `parts` 的材質名（armor/dark/trim/glow/armorE/glowE）由
   `enemy-parts.ts` 的 `enemyPalette(tint)` 解析 —— 型別表只寫形狀。 */

export var RING = [
  /* ─ 8 ─────────────────────────────────────────────────────────
     NEST 巢 —— 全表唯一的環。不會追你、不會傷你，但它在旁邊你就永遠打不完。
     青色的第二個成員：兩隻青的剪影一個是牆一個是環，不可能認錯。 */
  {
    id:'nest', fam:'ring', code:'NEST', zh:'巢', role:'召喚・增援', tint:'azu',
    sil:'水平環＋中心珠', h:1.40, w:1.46, wt:0.5,
    spd:0.55, turn:0.8, gait:1.0, rng:5.0, tTel:1.20, tAtk:0.42, tRec:1.40,
    q0:{rg:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'加速', q:{rg:0.84}, sp:1.30, sc:0.92},
          {n:'護盾', q:{rg:1.22}, sp:0.72, sc:1.10}],
    parts:[
      pt('tor','armor',[1.46,1.46,1.05],[0,0.94,0],[HP,0,0], function(P,o){
          P.sx *= o.q.rg; P.sy *= o.q.rg; P.rz += o.t*0.55;
          P.y -= o.tel*0.10; }),
      pt('tor','glow', [1.02,1.02,0.85],[0,0.94,0],[HP,0,0], function(P,o){
          var k = (1 - 0.22*o.tel + 0.9*o.atk) * o.q.rg;
          P.sx *= k; P.sy *= k; P.rz -= o.t*1.1 + o.tel*3.0; }),
      pt('oct','dark', [0.50,0.60,0.50],[0,0.94,0],null, function(P,o){
          P.y += 0.07*Math.sin(o.t*1.4) - o.tel*0.30 + o.atk*0.55;
          var k = 1 + 0.5*o.atk; P.sx *= k; P.sz *= k; }),
      pt('cyl','trim', [0.15,0.98,0.15],[ 0.54,0.49,0.31],[0.28,0,-0.32]),
      pt('cyl','trim', [0.15,0.98,0.15],[-0.54,0.49,0.31],[0.28,0, 0.32]),
      pt('cyl','trim', [0.15,0.98,0.15],[0,0.49,-0.62],[-0.34,0,0])
    ],
    ex:[ pt('tor','glowE',[1.80,1.80,0.5],[0,0.62,0],[HP,0,0]),
         pt('box','armorE',[0.26,0.30,0.26],[ 0.70,1.06,0.40],[0,0,-0.2]),
         pt('box','armorE',[0.26,0.30,0.26],[-0.70,1.06,0.40],[0,0, 0.2]),
         pt('box','armorE',[0.26,0.30,0.26],[0,1.06,-0.80]),
         pt('cone','armorE',[0.28,0.46,0.28],[0,1.38,0]) ],
    pose:function(o){
      o.ry = 0.04*Math.sin(o.t*1.1);
      o.rp = 0; o.rr = 0; o.rz = 0;
    }
  },
  /* ── 家族 RING 環 ── 全表唯一的環。azu 是 NEST。 */
  {
    id:'reifen', fam:'ring', code:'REIFEN', zh:'箍', role:'滾進・纏繞', tint:'red',
    sil:'直立大環＋中心軸', h:1.22, w:1.20, wt:1.5,
    spd:2.9, turn:1.8, gait:2.0, rng:1.9, tTel:0.36, tAtk:0.26, tRec:0.60,
    q0:{rg:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'疾箍', q:{rg:0.84}, sp:1.48, sc:0.86},
          {n:'重箍', q:{rg:1.24}, sp:0.72, sc:1.20}],
    parts:[
      pt('tor','armor',[1.20,1.20,0.62],[0,0.60,0],[0,HP,0], function(P,o){
          var k = o.q.rg; P.sx*=k; P.sy*=k; P.rz += o.t*2.6*(0.3+o.mv) + o.atk*9; }),
      pt('tor','dark', [0.84,0.84,0.50],[0,0.60,0],[0,HP,0], function(P,o){
          var k = o.q.rg; P.sx*=k; P.sy*=k; P.rz -= o.t*1.8*(0.3+o.mv); }),
      pt('oct','glow', [0.32,0.32,0.32],[0,0.60,0],null, function(P,o){
          var k = 1 + 1.6*o.tel + 2.0*o.atk*(1-o.atk); P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('box','armor',[0.10,0.94,0.10],[0,0.60,0],null, function(P,o){
          P.sy *= o.q.rg; P.rx += o.t*2.6*(0.3+o.mv) + o.atk*9; }),
      pt('box','armor',[0.10,0.10,0.94],[0,0.60,0],null, function(P,o){
          P.sz *= o.q.rg; P.rx += o.t*2.6*(0.3+o.mv) + o.atk*9; }),
      pt('cyl','trim', [0.18,0.44,0.18],[0,0.60,0],[0,0,HP])
    ],
    ex:[ pt('tor','glowE',[1.42,1.42,0.28],[0,0.60,0],[0,HP,0], function(P,o){ P.rz += o.t*3.4; }),
         pt('oct','armorE',[0.24,0.24,0.24],[0,1.28,0]) ],
    pose:function(o){
      o.ry = 0.04*Math.abs(Math.sin(o.ph*Math.PI * 2))*o.mv;
      o.rp = o.tel*0.10;
      o.rz = -o.tel*0.22 + o.atk*0.95;
    }
  },
  {
    id:'kranz', fam:'ring', code:'KRANZ', zh:'冠', role:'環射・壓制', tint:'amb',
    sil:'水平環＋環上三管', h:1.32, w:1.34, wt:0.8,
    spd:1.2, turn:1.3, gait:1.5, rng:6.4, tTel:0.92, tAtk:0.32, tRec:1.15,
    q0:{rg:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'速轉', q:{rg:0.84}, sp:1.36, sc:0.90},
          {n:'廣冠', q:{rg:1.28}, sp:0.68, sc:1.16}],
    parts:[
      pt('tor','armor',[1.30,1.30,0.60],[0,0.94,0],[HP,0,0], function(P,o){
          var k = o.q.rg; P.sx*=k; P.sy*=k; P.rz += o.t*(0.5 + 3.0*o.tel); }),
      pt('cyl','armor',[0.15,0.66,0.15],[0,0.94,0.62],[HP,0,0], function(P,o){
          P.z *= o.q.rg; P.z -= o.atk*0.18; }),
      pt('cyl','armor',[0.15,0.66,0.15],[ 0.54,0.94,-0.31],[HP,0,-2.09], function(P,o){
          P.x *= o.q.rg; P.z *= o.q.rg; }),
      pt('cyl','armor',[0.15,0.66,0.15],[-0.54,0.94,-0.31],[HP,0, 2.09], function(P,o){
          P.x *= o.q.rg; P.z *= o.q.rg; }),
      pt('oct','glow', [0.36,0.36,0.36],[0,0.94,0],null, function(P,o){
          var k = 1 + 1.5*o.tel + 1.8*o.atk*(1-o.atk); P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('cyl','trim', [0.24,0.94,0.24],[0,0.47,0])
    ],
    ex:[ pt('tor','glowE',[1.56,1.56,0.24],[0,0.78,0],[HP,0,0], function(P,o){ P.rz -= o.t*1.9; }),
         pt('oct','armorE',[0.26,0.26,0.26],[0,1.30,0]) ],
    pose:function(o){
      o.ry = 0.03*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.02 + 0.03*o.mv;
    }
  },
  {
    id:'wirbel', fam:'ring', code:'WIRBEL', zh:'渦', role:'旋渦・吸引', tint:'vio',
    sil:'水平雙環反轉', h:1.28, w:1.42, wt:0.7,
    spd:1.5, turn:1.4, gait:1.6, rng:4.6, tTel:1.05, tAtk:0.60, tRec:1.20,
    q0:{rg:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'快渦', q:{rg:0.84}, sp:1.36, sc:0.90},
          {n:'巨渦', q:{rg:1.30}, sp:0.68, sc:1.18}],
    parts:[
      pt('tor','armor',[1.40,1.40,0.50],[0,0.86,0],[HP,0,0], function(P,o){
          var k = o.q.rg*(1 + 0.20*o.atk); P.sx*=k; P.sy*=k;
          P.rz += o.t*(0.6 + 5.5*o.tel + 9*o.atk); }),
      pt('tor','dark', [0.96,0.96,0.46],[0,1.02,0],[HP,0,0], function(P,o){
          var k = o.q.rg*(1 - 0.22*o.tel); P.sx*=k; P.sy*=k;
          P.rz -= o.t*(0.9 + 6.5*o.tel); }),
      pt('oct','glow', [0.40,0.40,0.40],[0,0.94,0],null, function(P,o){
          var k = 1 + 0.3*Math.sin(o.t*4) + 1.6*o.tel + 1.4*o.atk; P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('box','glow', [1.10,0.06,0.16],[0,0.94,0],null, function(P,o){
          P.sx *= o.q.rg; P.ry += o.t*(0.6 + 5.5*o.tel + 9*o.atk); }),
      pt('cone','trim',[0.16,0.66,0.16],[ 0.36,0.33,-0.14],[Math.PI,0,0], legSwing( 1,0.33,0.20)),
      pt('cone','trim',[0.16,0.66,0.16],[-0.36,0.33,-0.14],[Math.PI,0,0], legSwing(-1,0.33,0.20))
    ],
    ex:[ pt('tor','glowE',[1.70,1.70,0.22],[0,0.60,0],[HP,0,0], function(P,o){ P.rz += o.t*2.4; }),
         pt('oct','armorE',[0.24,0.24,0.24],[0,1.26,0]) ],
    pose:function(o){
      o.ry = 0.05*Math.sin(o.t*1.6) + 0.03*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.02 + 0.03*o.mv - o.tel*0.06;
    }
  },
  {
    id:'maul', fam:'ring', deep:1, code:'MAUL', zh:'顎', role:'深層・咬合', tint:'red',
    sil:'環是嘴・環上有齒', h:1.24, w:1.38, wt:1.5,
    spd:2.3, turn:2.0, gait:2.0, rng:2.0, tTel:0.42, tAtk:0.30, tRec:0.62,
    q0:{rg:1},
    vars:[{n:'標準', q:{}, sp:1.00, sc:1.00},
          {n:'速咬', q:{rg:0.84}, sp:1.46, sc:0.88},
          {n:'巨顎', q:{rg:1.28}, sp:0.74, sc:1.18}],
    parts:[
      pt('tor','armor',[1.34,1.34,0.62],[0,0.72,0.06],[0.24,0,0.12], function(P,o){
          var k = o.q.rg*(1 + 0.34*o.tel - 0.30*o.atk); P.sx*=k; P.sy*=k; P.rz += o.t*0.5; }),
      pt('cone','armor',[0.22,0.52,0.22],[ 0.46,1.10,0.10],[2.5,0,-0.4], function(P,o){
          P.rx += 0.40*o.tel - 0.70*o.atk; }),
      pt('cone','armor',[0.20,0.46,0.20],[-0.40,0.30,0.02],[0.6,0,0.4], function(P,o){
          P.rx -= 0.40*o.tel - 0.70*o.atk; }),
      pt('oct','void',[0.62,0.62,0.40],[0,0.72,-0.04], null, function(P,o){
          var k = 1 + 0.7*o.tel; P.sx*=k; P.sy*=k; }),
      pt('box','glow',[0.10,0.10,0.90],[0.10,0.72,0.10], null, function(P,o){
          var k = 1 + 1.8*o.tel + 2.2*o.atk*(1-o.atk); P.sx*=k; P.sy*=k; }),
      pt('cyl','trim',[0.20,0.60,0.20],[0.04,0.30,-0.24],[0.2,0,0.14], legSwing(1,0.30,0.28))
    ],
    ex:[ pt('tor','glowE',[1.56,1.56,0.26],[0,0.72,0.02],[0.24,0,0.12], function(P,o){ P.rz -= o.t*2.2; }),
         pt('cone','armorE',[0.16,0.36,0.16],[-0.52,0.98,0.06],[2.3,0,0.5]) ],
    pose:function(o){ o.ry = 0.05*Math.abs(Math.sin(o.ph*Math.PI * 2))*o.mv;
      o.rp = 0.08 + 0.06*o.mv + o.tel*0.16 - o.atk*0.26; o.rr = -0.08;
      o.rz = -o.tel*0.22 + o.atk*0.86; }
  },
  {
    id:'leier', fam:'ring', deep:1, code:'LEIER', zh:'弦琴', role:'深層・弦射', tint:'amb',
    sil:'環＋橫過環面的弦', h:1.36, w:1.30, wt:0.8,
    spd:1.1, turn:1.2, gait:1.4, rng:6.6, tTel:1.00, tAtk:0.34, tRec:1.20,
    q0:{rg:1},
    vars:[{n:'標準', q:{}, sp:1.00, sc:1.00},
          {n:'速弦', q:{rg:0.84}, sp:1.34, sc:0.90},
          {n:'長弦', q:{rg:1.28}, sp:0.70, sc:1.16}],
    parts:[
      pt('tor','armor',[1.26,1.26,0.55],[0.04,0.92,0],[0,0.16,0.14], function(P,o){
          var k = o.q.rg; P.sx*=k; P.sy*=k; P.rz += o.t*0.4; }),
      pt('box','glow',[0.05,1.10,0.05],[-0.24,0.92,0.02],[0,0,0.14], function(P,o){
          P.sy *= o.q.rg; P.sx *= 1 + 3.0*clamp(o.tel*3, 0, 1); }),
      pt('box','glow',[0.05,1.16,0.05],[0.06,0.92,0.02],[0,0,0.14], function(P,o){
          P.sy *= o.q.rg; P.sx *= 1 + 3.0*clamp(o.tel*3 - 1, 0, 1); }),
      pt('box','glow',[0.05,1.04,0.05],[0.34,0.92,0.02],[0,0,0.14], function(P,o){
          P.sy *= o.q.rg; P.sx *= 1 + 3.0*clamp(o.tel*3 - 2, 0, 1); }),
      pt('oct','void',[0.40,0.40,0.34],[0.04,0.92,-0.10]),
      pt('cyl','trim',[0.22,0.66,0.22],[ 0.26,0.33,-0.02], null, legSwing( 1,0.33,0.24)),
      pt('cyl','trim',[0.20,0.58,0.20],[-0.24,0.29, 0.06], null, legSwing(-1,0.29,0.28))
    ],
    ex:[ pt('tor','glowE',[1.52,1.52,0.24],[0.04,0.92,0],[0,0.16,0.14]),
         pt('oct','armorE',[0.24,0.24,0.24],[0.30,1.32,-0.10]) ],
    pose:function(o){ o.ry = 0.03*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.04 + 0.03*o.mv - o.tel*0.10; o.rr = 0.07; o.rz = -o.atk*0.12; }
  }
];
